import { v4 } from 'uuid';

// пока нет userid затем переписываем его на userid
const temporaryScope = v4();

export const loadFromStorage = <T>(key: string, def: T, global = false): T => {
	const scope = StorageScope.scope || temporaryScope;
	const scopeKey = global ? key : `${scope}:${key}`;
	const item = localStorage.getItem(scopeKey) as string;
	return (JSON.parse(item) as T) ?? def;
};

export const saveToStorage = <T>(key: string, value: T, global = false) => {
	const scope = StorageScope.scope || temporaryScope;
	const scopeKey = global ? key : `${scope}:${key}`;
	const item = JSON.stringify(value);
	if (value === null || value === undefined) {
		localStorage.removeItem(key);
	} else {
		localStorage.setItem(scopeKey, item);
	}
};

export const loadFromSessionStorage = <T>(key: string, def: T): T => {
	const item = sessionStorage.getItem(key) as string;
	return (JSON.parse(item) as T) ?? def;
};

export const saveToSessionStorage = <T>(key: string, value: T): void => {
	const item = JSON.stringify(value);
	if (value === null || value === undefined) {
		sessionStorage.removeItem(key);
	} else {
		sessionStorage.setItem(key, item);
	}
};

export class StorageScope {
	private static _scope: string | null = null;

	static set scope(scope: string) {
		if (scope) {
			StorageScope._scope = scope;
		}
	}

	static get scope(): string | null {
		return StorageScope._scope;
	}

	static clean = () => {
		StorageScope._scope = null;
	};
}
